import React, { Component } from 'react';
import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { cpfMask } from '../../shared/masks';
import Input from '../../components/Input/Input';
import ReactPlayer from 'react-player'
import { updateEmployer } from '../../store/actions/employer';
import { Typography } from '@mui/material';
import Welcome from '../../assets/images/Grinning Face Emoji.H01.2k.png'
import { Box, Modal } from '@material-ui/core';
import { usageLog } from '../../store/actions/globalActions';

class FormInfo extends Component {
  constructor() {
    super();
    this.state = {
      modalOpen: true,
    };
  }

  componentDidMount() {
    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);
    usageLog('bemvindo/login', decodedToken.companyId, decodedToken.id)
  }

  render() {
    const styles = {
      dialog: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 690,
        height: 500,
        p: 4,
        backgroundColor: '#4650e6',
        borderRadius: '20px',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none'
      },
      image: {
        position: 'absolute',
        top: '-150px',
        left: '50%',
        transform: 'translateX(-50%)',
        width: '250px',
        height: '250px',
        zIndex: 1
      },
      title: {
        textAlign: 'center',
        marginTop: '50px',
        fontSize: '29px',
        fontWeight: 'bold',
        fontFamily: 'montserrat',
        color: 'white'
      },
      text: {
        textAlign: 'center',
        marginTop: '20px',
        color: 'white'
      },
      boxButton: {
        textAlign: 'center',
        marginTop: '50px',
      },
      button: {
        backgroundColor: "white",
        fontWeight: 'bold',
        borderRadius: '15px',
        width: '350px',
        height: '40px',
        fontSize: '15px'
      },
      reactplayer: {
        width: '35em',
        height: '20em',
        textAlign: 'center',
        marginTop:'10px',
      },
      container: {
        textAlign: 'center'
      }

    };
    const jwt = require('jsonwebtoken');
    const decodedToken = jwt.decode(localStorage.token);
    return (

      <Modal
        open={this.state.modalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"

      >
        <Box sx={styles.dialog}>
          <img alt="icon" src={Welcome} style={styles.image} />
          {/* <Box sx={styles.title}>
            <Typography style={styles.title}>Bem-vindo ao Puntu!</Typography>
          </Box> */}
          {/* <Box sx={styles.text}>
            <Typography>Estamos felizes em tê-lo conosco!</Typography>
            <Typography sx={{ marginTop: '20px' }}>
              Cadastre seus funcionários para começar a usar o Puntu<br />
              e simplificar o controle de ponto na sua empresa.
            </Typography>
          </Box> */}
<Box style={{alignItems: 'center', marginLeft: -6}}> 
<ReactPlayer url={'https://youtu.be/EylO0zCT7A4?si=SIcUjwivfIT47LTJ&t=75'} controls={true} style={styles.reactplayer
        }> 
              </ReactPlayer>
</Box>
        
          <Box sx={styles.boxButton}>
            <Button
              type="submit"
              color="primary"
              style={styles.button}
              href='/colaboradores?type=bemvindo'
              onClick={() => {
                usageLog('bemvindo/login/cadastroFuncionario', decodedToken.companyId, decodedToken.id)
                this.setState({ modalOpen: false })
              }}
            >
              Cadastre seu primeiro funcionário
            </Button>
          </Box>
        </Box>
      </Modal>

    );
  }
}

const mapStateToProps = state => ({
  data: state.data.data,
});

const mapDispatchToProps = dispatch => ({
  onUpdateEmployer: (data, isModal) => dispatch(updateEmployer(data, isModal)),
});


export default connect(mapStateToProps, mapDispatchToProps)(FormInfo);
